import { FaberApi } from 'api'

class NetworkAPI {
  static async getNetworkDetails(whitelistName: string, faberToken: string) {
    return FaberApi.httpGet(
      `/sim/ops/whitelist/${whitelistName}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }

  static async upsertNetworkDetails({ faberToken, payload }) {
    return FaberApi.httpPost(
      `/sim/ops/whitelist/upload`,
      { Authorization: `Bearer ${faberToken}` },
      payload
    )
  }

  static async getNetworkDetailData(
    whitelistId: string,
    faberToken: string,
    version?: string
  ) {
    let url = `/sim/ops/whitelist/item?whitelistId=${whitelistId}&format=table`

    if (version) {
      url = url + `&version=${version}`
    }

    return FaberApi.httpGet(url, {
      Authorization: `Bearer ${faberToken}`
    })
  }

  static async getAllNetworkDetailData(faberToken: string) {
    return FaberApi.httpGet(`/sim/ops/whitelist/all`, {
      Authorization: `Bearer ${faberToken}`
    })
  }
}

export default NetworkAPI
